import { render, staticRenderFns } from "./AddPageMedia.vue?vue&type=template&id=1381d4e4&"
import script from "./AddPageMedia.vue?vue&type=script&lang=ts&"
export * from "./AddPageMedia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports